import { utils, theme } from '@dls/web';
const media = utils.createMediaQueries({
  xs: "0em",
  sm: theme.breakpoints.xs,
  md: theme.breakpoints.sm,
  lg: theme.breakpoints.md,
  xl: theme.breakpoints.lg,
  xxl: theme.breakpoints.xl
});
export { media };